import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import {
    ENVIAR_GLOSAS_CON_CODIGO,
    GENERAR_ARCHIVO_FTP,
    ENVIAR_MASIVO_GLOSAS,
    ERROR_AUTORIZACION,
    ERROR_ENVIO_GLOSAS_CON_CODIGO,
    ERROR_ENVIO_MASIVO_GLOSAS,
    ENVIO_EXITOSO_GLOSAS_CON_CODIGO,
    ENVIO_EXITOSO_MASIVO_GLOSAS,
    DESCARGAR_PLANTILLA_MASIVO_GLOSAS,
    PLANTILLA_MASIVO_GLOSAS_OBTENIDA,
    ERROR_OBTENIENDO_PLANTILLA_MASIVO_GLOSAS,
    LIMPIAR_MENSAJES_MASIVO_GLOSAS,
    GENERACION_ARCHIVO_ERROR,
    GENERACION_EXITOSA_ARCHIVO,
    errorAutorizacion,
    errorEnvioGlosasConCodigo,
    errorEnvioMasivoGlosas,
    envioExitosoGlosasConCodigo,
    envioExitosoMasivoGlosas,
    plantillaMasivoGlosasObtenida,
    errorObteniendoPlantillaMasivoGlosas,
    generacionExitosaArchivo,
    generacionArchivoError
} from "../modulos/procesarMasivoGlosasActions";

export const enviarGlosasConCodigoEpic = action$ =>
    action$.ofType(ENVIAR_GLOSAS_CON_CODIGO)
        .mergeMap((action: any) => {

            const url = `sat/masivo-glosas/envio-codigo-glosa`;

            return authenticatedAjax
                .post(
                    url,
                    action.datosEnvioGlosa,
                    { 'Content-Type': 'application/json', 'proceso': 'MASIVO_GLOSAS' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return envioExitosoGlosasConCodigo(respuesta.registrosEncontrados);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioGlosasConCodigo(mensajeRespuesta)];
                    }
                });
        });

export const generarArchivoFtpEpic = action$ =>
    action$.ofType(GENERAR_ARCHIVO_FTP)
        .mergeMap((action: any) => {

            const url = `sat/consultar/generar-ftp`;

            return authenticatedAjax
                .post(
                    url,
                    action.datosGenerarFtp,
                    { 'Content-Type': 'application/json', 'proceso': 'GENERAR_CONSULTA_FTP' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return generacionExitosaArchivo(respuesta.registrosEncontrados, respuesta.registrosParametro, respuesta.correos);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [generacionArchivoError(mensajeRespuesta)];
                    }
                });
        });

export const enviarMasivoGlosasEpic = action$ =>
    action$.ofType(ENVIAR_MASIVO_GLOSAS)
        .mergeMap((action: any) => {

            const url = `sat/masivo-glosas/envio-glosas-masivo`;

            return authenticatedAjax
                .upload(
                    url,
                    action.archivoEnvioGlosas, {}, { 'proceso': 'MASIVO_GLOSAS' }
                )
                .map((response) => {
                    return envioExitosoMasivoGlosas();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioMasivoGlosas(mensajeRespuesta)];
                    }
                });
        });

export const descargarPlantillaMasivoGlosasEpic = action$ =>
    action$.ofType(DESCARGAR_PLANTILLA_MASIVO_GLOSAS)
        .mergeMap((action: any) => {

            const url = `sat/descargas/plantilla-masivo-glosas`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_masivo_glosas.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return plantillaMasivoGlosasObtenida();
                }).catch(response =>
                    [errorObteniendoPlantillaMasivoGlosas()]
                );
        });

export const envioMasivoGlosasReducer = (state =
    {
        estadoEnvioIndividual: REQUEST.NONE,
        estadoEnvioMasivo: REQUEST.NONE,
        estadoGenerarArchivo: REQUEST.NONE,
        mensajeUsuario: undefined,
        registrosEncontrados: undefined,
        registrosParametro: undefined,
        correos: undefined
    }, action: AnyAction) => {

    switch (action.type) {

        case ENVIAR_GLOSAS_CON_CODIGO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.PENDING,
                estadoEnvioMasivo: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.NONE
            };
        case GENERAR_ARCHIVO_FTP:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.PENDING
            };
        case ENVIAR_MASIVO_GLOSAS:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.PENDING,
                estadoGenerarArchivo: REQUEST.NONE
            };
        case ENVIO_EXITOSO_GLOSAS_CON_CODIGO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.SUCCESS,
                estadoEnvioMasivo: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.NONE,
                registrosEncontrados: action.registrosEncontrados
            };
        case GENERACION_EXITOSA_ARCHIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.NONE,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.SUCCESS,
                registrosEncontrados: action.registrosEncontrados,
                registrosParametro: action.registrosParametro,
                correos: action.correos
            };
        case ENVIO_EXITOSO_MASIVO_GLOSAS:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.SUCCESS,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.NONE
            };
        case ERROR_AUTORIZACION:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.FORBIDDEN,
                estadoEnvioMasivo: REQUEST.FORBIDDEN,
                estadoGenerarArchivo: REQUEST.FORBIDDEN
            };
        case ERROR_ENVIO_GLOSAS_CON_CODIGO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case ERROR_ENVIO_MASIVO_GLOSAS:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case GENERACION_ARCHIVO_ERROR:
            return {
                ...state,
                estadoGenerarArchivo: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case LIMPIAR_MENSAJES_MASIVO_GLOSAS:
            return {
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.NONE,
                estadoGenerarArchivo: REQUEST.NONE,
                registrosEncontrados: undefined,
                mensajeUsuario: undefined,
                registrosParametro: undefined,
                correos: undefined
            };
        case PLANTILLA_MASIVO_GLOSAS_OBTENIDA:
        case ERROR_OBTENIENDO_PLANTILLA_MASIVO_GLOSAS:
            return { ...state };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_masivo_glosas/modulos/procesarMasivoGlosasReducers.ts